import { Link } from "react-router-dom";
const BibleSemanticMap = () => {
    return ( 
      <div> 
        <h3 style={{textAlign:'center', padding: '1em'}}>Semantic Map of the Holy Bible</h3>
        <iframe src="https://bomextest.org/Widgets/SemanticMaps/BibleSemanticMap/index.html" style={{height: "800px", width: "100%", border:"none"}} ></iframe>
      </div>
     );
  }
   
  export default BibleSemanticMap;
  